import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import { EMPTY_STATE } from '../constants';
import { FilterValues, PeoplePageParamKeys } from '../customPeopleTagTypes';
import { usePeoplePageSearchState } from '../hooks/usePeoplePageQueryState';

const EmptyStateWrapper = styled.div`
  margin: 0 auto;
  padding: 64px 0;
  text-align: center;
  width:480px;

  h5 {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    padding: 32px 0 12px;
  }

  p {
    font-weight: 450;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const EmptyState: FunctionComponent = () => {
  const [state] = usePeoplePageSearchState();

  const emptyKey = state.search ? PeoplePageParamKeys.Search : state.filter || FilterValues.Untagged;

  return (
    <EmptyStateWrapper>
      <img alt='no results' src={EMPTY_STATE[emptyKey].imgSrc} />
      <h5>{EMPTY_STATE[emptyKey].heading}</h5>
      <p>{EMPTY_STATE[emptyKey].subheading}</p>
    </EmptyStateWrapper>
  );
};
